import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// rem适应
import remConfig from '@/utils/remConfig'
window.addEventListener('resize',remConfig);

// vant css
import 'vant/lib/index.css'

// 通用自定义css
import '@/styles/public_qjc.css'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	// 页面标题写在路由中
	document.title = to.meta.title;
	
	// 大禹项目(打包后)资源请求提升为https
	if(/^\/dayu*./.test(to.fullPath) && process.env.NODE_ENV != 'development'){
		var DayuMeta = document.createElement('meta');
		DayuMeta.httpEquiv = "Content-Security-Policy";
		DayuMeta.content = "upgrade-insecure-requests";
		document.head.appendChild(DayuMeta);
	}
	
	// 移动端只能扫码进入
	// 筛选
	var mPathRegs = [/^\/m\/*./, /^\/HK\/m\/*./, /^\/yzzx\/m\/*./, /^\/dayu\/m\/*./],// 移动端路由验证(是否为需要检测的移动端路由)
		mCodeErrNames = ['mCodeErr', 'HKmCodeErr', 'yzzxmCodeErr', 'dayumCodeErr'],// 二维码错误路由名称(二维码页面白名单)
		mHomeNames = ['mHome', 'HKmHome', 'yzzxmHome', 'dayumHome'];// 移动端首页名称(标识在前后加mHome，用来筛选当前进入是否首页，下面对比时间戳超时跳转也有用到)
		
	if(mPathRegs.filter((item) => item.test(to.fullPath)).length > 0){
		if(mCodeErrNames.indexOf(to.name) != -1 || sessionStorage.getItem('codeTimestamp')){// 二维码失效页和已存在sessionStorage无限制
			next();
		}else if(mHomeNames.indexOf(to.name) != -1){// 首页检测和存储sessionStorage
			var timestamp = to.query.timestamp,
				nowTimestamp = new Date().getTime()/1000;
			if(timestamp){
				// 对比时间戳,二维码有效期1分钟,距离扫码超过1分5秒不能进(5秒防止网速加载过慢)
				if((nowTimestamp - timestamp) > 65){
					next({
						path: to.name.replace('mHome', '') + '/m/codeErr',// 进入当前路由对应二维码错误页
						query: {
							codeUrl: location.href
						}
					});
				}else{
					sessionStorage.setItem('codeTimestamp', timestamp);
					next();
				}
			}else{
				next(false);
			}
		}else{
			history.back();
		}
	
	}else{
		next();
	}
	
})

router.afterEach(() => {
	// 初始化rem,区分PC wap切换
	remConfig();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
